import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'nio-one-column-modal',
    templateUrl: './one-column-modal.component.html',
    styleUrls: ['./one-column-modal.component.scss'],
    standalone: false
})
export class OneColumnModalComponent {
  constructor(
    public dialogRef: MatDialogRef<OneColumnModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}
}
